import { render, staticRenderFns } from "./CourseProjectOld.vue?vue&type=template&id=dfe4f1ca&"
import script from "./CourseProjectOld.vue?vue&type=script&lang=js&"
export * from "./CourseProjectOld.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports